/**
 * Style File — Costing & BOM screen. One of the 7 process screens reached
 * from Overview's "Work on this style" rail (`style-overview-page.tsx`).
 *
 * @see docs/product/garment-os-screen-build-plan.md §A
 */
import { Alert } from "@flint/ui";
import { trpc } from "../../../lib/trpc.js";
import type { StyleStatus } from "../lib/status.js";
import { StyleCockpitChrome } from "./style-cockpit-chrome.js";
import { CostingSection } from "./costing-section.js";

export function StyleCostingPage({ styleId }: { styleId: string }) {
  const query = trpc.styles.get.useQuery({ id: styleId });

  if (query.isLoading) return <p className="p-6 text-sm text-muted">Loading…</p>;
  if (query.error || !query.data) {
    return (
      <div className="p-6">
        <Alert intent="bad" title="Couldn't load style file" description={query.error?.message ?? "Not found."} />
      </div>
    );
  }

  const style = query.data;
  const status = style.status as StyleStatus;
  const meta =
    status === "draft"
      ? "Confirm the order first"
      : status === "po_confirmed"
        ? "Build the cost sheet"
        : "Locked · cost sheet frozen";

  return (
    <StyleCockpitChrome styleId={styleId} style={style}>
      <div id="sec-costing" className="scroll-mt-28">
        <h1 className="text-base font-bold leading-tight tracking-tight text-ink">Costing &amp; BOM</h1>
        <p className="mt-0.5 text-xs text-muted">{meta}</p>
      </div>
      <div className="mt-4">
        <CostingSection
          styleId={styleId}
          styleStatus={status}
          currency={style.currency}
          orderQty={style.grid.totalQty}
          styleName={style.name}
          styleRef={style.styleRef}
          buyerName={style.buyerName}
        />
      </div>
    </StyleCockpitChrome>
  );
}
